<template>
  <el-button @click="handleClick">Click</el-button>

</template>

<script>

import { reactive, toRefs, onMounted } from "vue";

export default {
  name: "Test",
  setup() {
    const refs = {
    };

    const data = reactive({
    });

    function handleClick() {
      alert('CLICKED!')
    }


    onMounted(() => {
    });

    return { ...toRefs(data), ...toRefs(refs),
      handleClick
    };
  }
}
</script>

<style scoped>
</style>